import { Card, Row, Tabs } from 'antd';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import OrganizationExportImportLogs from './organization-export-import-logs/organization-export-import-logs';
import OrganizationDbLogs from './organization-db-logs/organization-db-logs';
import OrganizationInconsistencyLogs from './organization-db-inconsistency-logs/organization-db-inconsistency-logs';
import { OrganizationLogsContext } from '.';

const OrganizationLogs: FC = () => {
  const { activeTab } = useContext(OrganizationLogsContext);
  const { t } = useTranslation();

  setHeader(t('DevLogs'));
  setRoutes([
    { path: '', breadcrumbName: t('Home') },
    { path: 'dev-logs', breadcrumbName: t('DevLogs') },
  ]);

  return (
    <Row align="top" justify="space-between">
      <Card className="card-table" style={{ width: '100%' }}>
        <Row align="top" justify="space-between">
          <Tabs defaultActiveKey={activeTab} style={{ width: '100%', height: '100%', marginLeft: '20px', marginRight: '20px' }}>
            <Tabs.TabPane tab={t('DatabaseLogs')} key="database">
              <OrganizationDbLogs />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('DatabaseInconsistencyLogs')} key="database-inconsistency">
              <OrganizationInconsistencyLogs />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('ImportExport')} key="import-export">
              <OrganizationExportImportLogs />
            </Tabs.TabPane>
          </Tabs>
        </Row>
      </Card>
    </Row>
  );
};

export default OrganizationLogs;
